import { render, staticRenderFns } from "./emailNewslettersSettings.vue?vue&type=template&id=517c5230&scoped=true&"
import script from "./emailNewslettersSettings.vue?vue&type=script&lang=js&"
export * from "./emailNewslettersSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517c5230",
  null
  
)

export default component.exports